import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AbstractPageSearchFormComponent } from '../../search/form/abstract-page-search-form.component';
import { NPageSearch } from '../../search/page-search.interfaces';
import { NPageHeader } from '../page-header.component';

@Component({
    selector: 'page-header-search-form',
    templateUrl: './page-header-search-form.html',
    styleUrls: ['./page-header-search-form.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageHeaderSearchFormComponent extends AbstractPageSearchFormComponent {
    /**
     * Icon when form is visible
     */
    @ViewChild('iconOn', { read: ElementRef })
    private iconOnRef?: ElementRef<HTMLElement>;

    /**
     * Icon when form is not visible
     */
    @ViewChild('iconOff', { read: ElementRef })
    private iconOffRef?: ElementRef<HTMLElement>;

    /**
     * If form is visible
     */
    override isVisible = false;

    @Output()
    isFormVisible = new EventEmitter<boolean>();

    @ViewChild('input', { read: ElementRef })
    private input?: ElementRef<HTMLInputElement>;

    /**
     * Currently set animation shift
     */
    private animationShift = 0;

    private timeout?: number;
    /**
     * Toggle full component visibility
     */
    toggleVisibility(to: boolean) {
        if (this.isVisible !== to) {
            this.isVisible = to;
            this.updateAnimationShift();

            if (to) {
                this.isFormVisible.next(to);
            }
            this.timeoutService.setTimeout(() => {
                if (to) {
                    this.renderer2.addClass(this.elementRef.nativeElement, '_open');
                } else {
                    this.renderer2.removeClass(this.elementRef.nativeElement, '_open');
                    this.reset();
                    this.isFormVisible.next(to);
                }
            }, 250); // delay it so that animation shift is applied
            if (to) {
                this.toggleService.open([NPageHeader.MEGANAV_GROUP_ID, NPageSearch.SEARCH_MEGANAV_KEY]);
                this.detectChanges();
            } else {
                this.toggleService.close([NPageHeader.MEGANAV_GROUP_ID, NPageSearch.SEARCH_MEGANAV_KEY]);
            }
        }
    }

    /**
     * To show opening/closing animation we need to know distance between the form (visible on focus) and the icon (visible on blur)
     */
    private updateAnimationShift() {
        if (!this.iconOffRef || !this.iconOnRef) {
            this.logger.error('Search form template is missing element references. Check code');
        } else {
            const animationShift =
                (this.isVisible ? this.animationShift : 0) +
                this.iconOffRef.nativeElement.getBoundingClientRect().right -
                this.iconOnRef.nativeElement.getBoundingClientRect().right;
            this.animationShift = animationShift;
            this.elementRef.nativeElement.style.setProperty('--animation-shift', `${animationShift}px`);
        }
    }

    override ngOnDestroy(): void {
        this.toggleVisibility(false);
        super.ngOnDestroy();
    }

    override goToSearchView() {
        this.input?.nativeElement.blur();
        super.goToSearchView();
    }
}
